import React, { useState, useEffect } from "react";
// material
import { Card, CircularProgress, Typography } from "@mui/material";
import { Stack, Container, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Page from "../components/Page";

import { getSetting, UpdatePrimeDescriptionSetting } from "src/api/updateSetting";
import { notification } from "src/utils/messages";
import { CKEditor } from "ckeditor4-react";
import CustomLoader from "src/components/CustomLoader";

const DescriptionEdit = () => {
  const [getdata, setgetdata] = useState({
    prime_privacy_policy_content: "",
    prime_terms_condition_content: ""
  });

  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchchapterlist() {
    try {
      const resp = await getSetting();
      if (resp.status == 1) {
        setgetdata(resp.data);
        setIsLoaded(true);
      }
    } catch {}
  }

  useEffect(() => {
    fetchchapterlist();
  }, []);

  const handleSubmit = async () => {
    const settingData = {
      s_id: 1,
      prime_privacy_policy_content: getdata.prime_privacy_policy_content,
      prime_terms_condition_content: getdata.prime_terms_condition_content
    };

    const jssettingData = JSON.stringify(settingData);

    setIsLoading(true);
    const resp = await UpdatePrimeDescriptionSetting(jssettingData);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      fetchchapterlist();
    }
  };

  return (
    <Page title="Description Edit | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Description Edit
          </Typography>
        </Stack>
        <Card style={{ marginBottom: "25px", padding: "25px" }}>
          <Stack spacing={10} style={{ marginBottom: "15px" }}>
            {isLoaded ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>Privacy Policy</h3>
                    <CKEditor
                      // key={getdata?.prime_privacy_policy_content || ""}
                      initData={getdata?.prime_privacy_policy_content || ""}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font", // adds font + color options
                        removeButtons: "", // keep all defaults
                        colorButton_colors:
                          // 🔹 Default CKEditor palette (taken from docs)
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          // 🔹 Your extra theme colors (example: brand palette)
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          prime_privacy_policy_content: data
                        }));
                      }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>Terms & Condition</h3>
                    <CKEditor
                      // key={getdata?.prime_terms_condition_content || ""}
                      initData={getdata?.prime_terms_condition_content}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font", // adds font + color options
                        removeButtons: "", // keep all defaults
                        colorButton_colors:
                          // 🔹 Default CKEditor palette (taken from docs)
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          // 🔹 Your extra theme colors (example: brand palette)
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          prime_terms_condition_content: data
                        }));
                      }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            ) : (
              <CustomLoader />
            )}
          </Stack>
          <Button
            onClick={handleSubmit}
            style={{ marginTop: "15px" }}
            variant="contained"
            disabled={isLoading}
            startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
          >
            Update
          </Button>
        </Card>
      </Container>
    </Page>
  );
};

export default DescriptionEdit;
